module.exports = "<cat-menu-left></cat-menu-left>\n<oab-top-bar></oab-top-bar>\n<div class=\"cat__content\">\n    <router-outlet></router-outlet>\n</div>\n"